// API Exports
export { api, apiGet, apiPost, apiPatch, apiPut, apiDelete, apiUpload, apiDownload, apiBatch } from './client'
export * from './auth'
export * from './products'
export * from './inventory'
export * from './pos'
export * from './purchases'

// React Query Keys
export const queryKeys = {
  // Auth
  user: (id?: string) => id ? ['user', id] as const : ['user'] as const,
  tenant: () => ['tenant'] as const,

  // Products
  products: (params?: any) => ['products', params] as const,
  product: (id: string) => ['product', id] as const,
  categories: (params?: any) => ['categories', params] as const,
  category: (id: string) => ['category', id] as const,
  brands: (params?: any) => ['brands', params] as const,
  brand: (id: string) => ['brand', id] as const,
  variants: (productId: string, params?: any) => ['variants', productId, params] as const,
  variant: (productId: string, variantId: string) => ['variant', productId, variantId] as const,

  // Inventory
  warehouses: (params?: any) => ['warehouses', params] as const,
  warehouse: (id: string) => ['warehouse', id] as const,
  stockLevels: (params?: any) => ['stock-levels', params] as const,
  stockSummary: (productId: string) => ['stock-summary', productId] as const,
  movements: (params?: any) => ['movements', params] as const,
  transfers: (params?: any) => ['transfers', params] as const,
  adjustments: (params?: any) => ['adjustments', params] as const,
  receives: (params?: any) => ['receives', params] as const,
  lowStock: (params?: any) => ['low-stock', params] as const,
  cycleCounts: (params?: any) => ['cycle-counts', params] as const,

  // Purchases
  purchaseOrders: (params?: any) => ['purchase-orders', params] as const,
  purchaseOrder: (id: string) => ['purchase-order', id] as const,
  suppliers: (params?: any) => ['suppliers', params] as const,
  supplier: (id: string) => ['supplier', id] as const,
  bills: (params?: any) => ['bills', params] as const,
  bill: (id: string) => ['bill', id] as const,
  supplierPayments: (params?: any) => ['supplier-payments', params] as const,

  // POS
  cart: () => ['cart'] as const,
  sales: (params?: any) => ['sales', params] as const,
  sale: (id: string) => ['sale', id] as const,
  payments: (saleId: string) => ['payments', saleId] as const,
  receipts: (saleId: string) => ['receipts', saleId] as const,
  shifts: (params?: any) => ['shifts', params] as const,
  currentShift: () => ['shift', 'current'] as const,
  shift: (id: string) => ['shift', id] as const,

  // Users
  users: (params?: any) => ['users', params] as const,
  roles: (params?: any) => ['roles', params] as const,
  role: (id: string) => ['role', id] as const,
  permissions: () => ['permissions'] as const,

  // Settings
  settings: () => ['settings'] as const,
} as const